export function isWithinLast(
  time: string | Date,
  maxAgeMs: number
): boolean {
  const date = typeof time === 'string' ? new Date(time) : time;
  return Date.now() - date.getTime() < maxAgeMs;
}